import DistributorDetails from '@/pages/(shared)/distributor/detail/components/distributorDetails';

import {DistributorProvider} from './providers/distributorProvider';

export function DistributorDetailsPage() {
  return (
    <DistributorProvider>
      <DistributorDetails />
    </DistributorProvider>
  );
}
